import React from 'react';
import axios from 'axios';
import { withStyles } from '@material-ui/core/styles';
import Uppy from '@uppy/core';
import Tus from '@uppy/tus';
import { Dashboard, DragDrop } from '@uppy/react';

import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';

const useStyles = (theme) => ({
    uploaderWrapper: {
    }
});

class Uploader extends React.PureComponent {
    constructor(props) {
        super(props);

        const {setCountFiles, setIsRetry, setCompleteFiles, setRemovedFile, changeTransferButtonState} = this.props;
        this.state = {
            isUploadCalled: false
        };

        this.uppy = Uppy({
            onBeforeFileAdded: (currentFile, files) => {
                if ( this.state.isUploadCalled ) {
                    return false;
                }
            },
            restrictions: { 
                maxFileSize: 3200 * 1024 * 1024, // 3200 MB (3.2 GB)
                maxNumberOfFiles: 50,
                allowedFileTypes: [
                    "image/jpeg",
                    "image/jpg",
                    "image/png",
                    "image/gif",
                    "image/webp",
                    "image/bmp",
                    "audio/mp4",
                    "audio/m4a",
                    "audio/x-m4a",
                    "audio/mpeg",
                    "audio/opus",
                    "audio/x-flac",
                    "audio/ogg",
                    "audio/x-wav",
                    "audio/wav",
                    "audio/amr",
                    "video/x-flv",
                    "video/mp2t",
                    "video/mp4",
                    "video/x-m4v",
                    "video/x-matroska",
                    "video/webm",
                    "video/quicktime",
                    "video/x-msvideo",
                    "video/x-ms-wmv",
                    "video/mpeg",
                    "video/avi",
                    // PDF
                    "application/pdf",
                  ] // the supported types
            },
            autoProceed: false
        }).on('file-added', (file) => {
            const countFiles = this.uppy.getFiles();
            setCountFiles(parseInt(countFiles.length));
        }).on('file-removed', (file) => {
            const countFiles = this.uppy.getFiles();
            setCountFiles(parseInt(countFiles.length));
            setRemovedFile(file);

            if (parseInt(countFiles.length) === 0) {
                this.setState({
                    isUploadCalled: false
                });
            }
        }).on('complete', (result) => {
            setCompleteFiles(result);
            // changeTransferButtonState(false);
        }).on('upload', (data) => {
            if (!this.state.isUploadCalled) {
                this.setState({
                    isUploadCalled: true
                });
            }
        }).on('upload-progress', (file, progress) => {
            setIsRetry(false);
            changeTransferButtonState(true);
        }).on('upload-error', (file, error) => {
            console.log('error with file:', file.id);
            console.log('error message:', error);
            setIsRetry(true);
        }).on('error', (error) => {
            console.log(error);
        });
    }

    async getDropFilesConfig() {
        const config = await axios.get("/drop/config")
            .then((res) => {
                return res.data;
            });
        return config;
    };

    async uppyUpload() {
        const {druid} = this.props;
        const config = await this.getDropFilesConfig();

        if (config) {
            this.uppy.setMeta({ 
                "druid": druid.toString(),
                "post-finish": config.api+"/drop/drop/add_file",
                "s": config.source,
                "t": config.dest,
                "p": druid.toString() + "/",
                "o": "",
                "tags": "-"
            });
            this.uppy.use(Tus, {
                id: `${druid.toString()}:tus:${Date.now().toString()}`,
                autoRetry: true,
                chunkSize: 100 * 1024 * 1024, // 100 MB
                endpoint: config.tus+"/files/",
                resume: false,
                removeFingerprintOnSuccess: true, 
                retryDelays: [0, 1000, 3000, 5000]
             });
            this.uppy.upload();
        }
    };

    startUpload() {
        const {druid} = this.props;
        if (druid) {
            this.uppyUpload();
        }
    }

    componentDidMount() {
        this.startUpload();
    }

    componentDidUpdate(prevProps) {
        if (this.props.druid === "") {
            this.setState({
                isUploadCalled: false
            });
            return false;
        } else if (this.props.druid !== prevProps.druid) {
            this.startUpload();
        }
    }

    render() {
        const {classes} = this.props;
        return (
            <div className={classes.uploaderWrapper}>
                <div className="uploader-dropzone">
                    <DragDrop id={"uploader-browse-anchor"} uppy={this.uppy} />
                </div>
                <Dashboard
                    animateOpenClose={false}
                    allowMultipleUploads={true}
                    height={"auto"}
                    hideCancelButton={true}
                    hideUploadButton={true}
                    locale={{
                        strings: {
                            browse: 'Browse Files',
                            dropPaste: 'Drop files here or click %{browse}'
                        } 
                    }}
                    plugins={[]}
                    proudlyDisplayPoweredByUppy={false}
                    showLinkToFileUploadResult={false}
                    showProgressDetails={true}
                    target="body"
                    theme="light"
                    uppy={this.uppy}
                    width="100%"
                    metaFields={[
                        { id: 'name', name: 'Name', placeholder: 'Title', render ({ value, onChange }, h) {
                            return h('input', {
                                value,
                                oninput: (event) => {
                                    onChange((event.target.value) ? event.target.value : "unnamed")
                                }
                            })
                        }},
                    ]}
                />
            </div>
        )
    };
};

export default withStyles(useStyles, {withTheme: true})(Uploader);